import "./style.scss";
import {useSelector} from "react-redux";
import logo from '@src/assets/images/logo/logoLine.webp';
import React, {useState} from "react";
import {FormattedMessage} from "react-intl";

const AboutUs = () => {
    const AboutUs = useSelector(state => state.UI)
    const [collapse , setCollapse] = useState(false)
    let about_us = AboutUs?.home?.about_us
    
    return (
        <div className='link-sections-section-about'>
            <div className='link-sections-section-about-logo mb-1'>
                {/*<img src={logo} width={120}/>*/}
                <FormattedMessage id={"about"}/>
                {" "}
                <FormattedMessage id={"companyName"} />
            </div>
            <div className='link-sections-section-about-content'>
                <p className='text-justify mb-0'>
                    {AboutUs && AboutUs?.home?.about_us}
                </p>

            </div>
        </div>
    );
};

export default AboutUs;
